/**
 * 等待
 * @param timeout 毫秒
 */
export default function delay(timeout: number) {
    return new Promise<void>((yes) => {
        setTimeout(() => {
            yes();
        }, timeout);
    });
}
